/** Stable login-session token from GET /api/session/ping (server session instance id). */

let sessionToken: string | undefined;
const listeners = new Set<() => void>();

export function getSessionToken(): string | undefined {
  return sessionToken;
}

export function setSessionToken(token: string | undefined): void {
  const next = token?.trim() || undefined;
  if (next === sessionToken) {
    return;
  }
  sessionToken = next;
  for (const cb of listeners) {
    cb();
  }
}

export function onSessionTokenChange(cb: () => void): () => void {
  listeners.add(cb);
  return () => {
    listeners.delete(cb);
  };
}
